import { render, staticRenderFns } from "./baselayout.vue?vue&type=template&id=3b4809c4&"
import script from "./baselayout.vue?vue&type=script&lang=js&"
export * from "./baselayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports